import { Box, Flex, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import logo from "../assets/caspeco-logo-white.svg";

import Spinner from "./spinner";

export const SplashScreen = () => {
	return (
		<Box bg={"#151411"} height="100vh">
			<Flex flexDirection="column" justify="center" align="center" h="100%">
				<img src={logo} alt="caspeco-logo" width={200} style={{ marginBottom: ThemeSpaceVariable.Medium }} />
				<Spinner size="lg" color="white" />
			</Flex>
		</Box>
	);
};
